/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { savedQueryApiService } from '../../../search/saved-queries/save-queries-service';
import { IQueryDefinition } from '../../../search/models/dtos';

export function useSavedQueriesByApplicationAreaId(applicationAreaId: string): IQueryDefinition[] {
  const [savedQuery, setSavedQuery] = useState<IQueryDefinition[]>([]);

  useEffect(() => {
    async function getSavedQueriesByApplicationAreaId() {
      const result = await savedQueryApiService.getSavedQueriesByApplicationAreaId(applicationAreaId);
      setSavedQuery(result);
    }
    getSavedQueriesByApplicationAreaId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return savedQuery;
}
